import type { ReactNode } from 'react'
import { ASSEMBLY_DEVICE } from '@/assets/brand'

export interface HeroKpi { label: ReactNode; value: ReactNode; unit?: ReactNode; delta?: ReactNode }

/** Record header used atop the Account workspace and Property detail.
 *  Navy variant carries the Assembly Device watermark at low opacity. */
export function RecordHero({
  eyebrow, title, badges, kpis, breadcrumb, actions, tone = 'navy',
}: {
  eyebrow?: ReactNode; title: ReactNode; badges?: ReactNode
  kpis?: HeroKpi[]; breadcrumb?: ReactNode; actions?: ReactNode
  tone?: 'navy' | 'light'
}) {
  return (
    <div className={`hero hero--${tone}`}>
      {tone === 'navy' && <div className="hero-device" style={{ backgroundImage: `url(${ASSEMBLY_DEVICE})` }} />}
      <div className="hero-content">
        {breadcrumb && <div className="hero-breadcrumb">{breadcrumb}</div>}
        <div className="hero-top">
          <div className="hero-titles">
            {eyebrow && <div className="hero-eyebrow">{eyebrow}</div>}
            <h1 className="hero-title mixed">{title}</h1>
            {badges && <div className="hero-badges">{badges}</div>}
          </div>
          {actions && <div className="hero-actions">{actions}</div>}
        </div>
        {kpis && kpis.length > 0 && (
          <div className="hero-kpis">
            {kpis.map((k, i) => (
              <div key={i} className="hero-kpi">
                <div className="hero-kpi-label">{k.label}</div>
                <div className="hero-kpi-value-row">
                  <span className="hero-kpi-value num">{k.value}</span>
                  {k.unit && <span className="hero-kpi-unit">{k.unit}</span>}
                </div>
                {k.delta && <div className="hero-kpi-delta">{k.delta}</div>}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
